import {$, T} from "../../common/drupal/drupal";

class ParagraphProducts {

    /**
     * Initialize event listeners
     */
    init () {
        // slide Paragraph products
        let slideProductsId = 0;
        let slideProducts = [];
        $('.ProductList-products:not(.NodeHome-products-products, .swiper-container)').each(function () {
            if ($(this).find('.ProductList-item').length  > 1) {
                $(this).addClass('swiper-container').find('.ProductList-item').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
                $(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
                var homeSlide = new Swiper($(this), {
                    slidesPerView: 'auto',
                    speed: 500,
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
                slideProductsId++;
            }
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphProducts = new ParagraphProducts();
